module.exports = __webpack_public_path__ + "static/handle-last-minute changes-aef77459473c20e90c53ed01b7344919.png";